import React from 'react';
import OdezaAppStandalone from 'odeza-customer-chat-core/src/OdezaAppStandalone';
import {config} from './config';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {QUEUE_NAME_CH,} from "./constants";

import logo from "./images/Covenant_Health.png";
import avatar from "./images/Covenant_Health_Icon_Logo.png";

function App() {

    const customRoutes = [
        {route: '/', startQueueName: QUEUE_NAME_CH},
    ];

    const setLogosByQueue = (config, queueName) => {
        console.log(queueName)
        config.avatarUrl = avatar;
        config.chatLogo = logo;
    };

    const getStyleByQueue = (config, queueName) => {
        return <style>
            {
                ".template__href," +
                ".endChatButton," +
                ".endLiveChatButton," +
                ".appointment-button," +
                ".ask_name button {" +
                "  background-color: #6ec1dd !important;" +
                "}" +
                ".slick-prev:before, .slick-next:before {" +
                "  color: #6ec1dd !important;" +
                "}" +
                ".sendMessage polygon#Path {" +
                "  stroke: #6ec1dd !important;" +
                "  fill: #6ec1dd !important;" +
                "}" +
                ".btn_start_over," +
                ".go_back_button {" +
                "  color: #6ec1dd !important;" +
                "  background-color: unset !important;" +
                "}"
            }
        </style>
    }

    return (
        <Router>
            <Switch>
                {/* --- Custom routes --- */}
                {
                    customRoutes.map((record, key) => {
                        return <Route key={key} path={process.env.PUBLIC_URL + record.route}
                                      render={(props) => {
                                          config.startQueueName = record.startQueueName;
                                          setLogosByQueue(config, record.startQueueName);
                                          return <>
                                              {getStyleByQueue(config, record.startQueueName)}
                                              <base target="_target"/>
                                              <OdezaAppStandalone
                                                  {...props}
                                                  config={config}
                                                  startQueueName={record.startQueueName}
                                              />
                                          </>
                                      }}
                        />
                    })
                }
                {/*--- Main\Default route ---*/}
                {/*
				<Route path={process.env.PUBLIC_URL + "/:mrn?/:department?/:ref?/:username?"}
					   render={(props) => (
						   <OdezaAppStandalone
							   {...props}
							   config={config}
						   />
					   )}
				/>
				*/}
            </Switch>
        </Router>
    );
}

export default App;
